export default __webpack_public_path__ + "static/media/mobile_app.b6c663ae.svg";